import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { GlobalResponse } from '@app/shared-module/models';
import { Constants } from '@app/shared-module/constants';
import { AdminService } from '@app/services/admin.service';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-update-max-doctor',
  templateUrl: './update-max-doctor.component.html',
  styleUrls: ['./update-max-doctor.component.css']
})
export class UpdateMaxDoctorDialogComponent {
  activeDoctor: string;
  disableButton = false;
  @BlockUI() blockUI: NgBlockUI;

  constructor(
    public dialogRef: MatDialogRef<UpdateMaxDoctorDialogComponent>,
    private service: AdminService,
    private toastr: ToastrService
  ) { }

  updateCount() {
    this.dialogRef.close(this.activeDoctor);
  }
  changeMaxDoctor() {
    if (Number(this.activeDoctor) > 0) {
      this.disableButton = true;
    } else {
      this.disableButton = false;
    }
  }

}
